import { FC, createContext, useContext } from "react";
import { LayerTypeProviderProps } from "../../../types";
import { PlanningState, PlanningStateDispatch, usePlanningFilterState } from "../state/usePlanningFilterState";

interface PlanningApplicationsContextType {
  state: PlanningState;
  stateDispatch: PlanningStateDispatch;
}

const PlanningApplicationsContext = createContext<PlanningApplicationsContextType | null>(null);

export const usePlanningApplicationsContext = () => {
  const context = useContext(PlanningApplicationsContext);
  if (!context) {
    throw new Error("usePlanningApplicationsContext must be used within a PlanningApplicationsProvider");
  }
  return context;
};

export const PlanningApplicationsProvider: FC<LayerTypeProviderProps> = ({ children }) => {
  const [state, stateDispatch] = usePlanningFilterState("planning-applications-v2-filters");

  return (
    <PlanningApplicationsContext.Provider
      value={{
        state,
        stateDispatch,
      }}
    >
      {children}
    </PlanningApplicationsContext.Provider>
  );
};
